import { render, staticRenderFns } from "./conflictModal.vue?vue&type=template&id=f6ed2f00&scoped=true&"
import script from "./conflictModal.vue?vue&type=script&lang=ts&"
export * from "./conflictModal.vue?vue&type=script&lang=ts&"
import style0 from "./conflictModal.vue?vue&type=style&index=0&id=f6ed2f00&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ed2f00",
  null
  
)

export default component.exports